import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);

import { commonStore }   from '@store/commonStore';
import { projectManager }   from '@store/projectStore';
import { cadManager }       from '@store/cadStore';
import { erpManager }       from '@store/erpStore';

export const store = new Vuex.Store({
    modules: {
        commonStore,
        project:    projectManager,
        cad:        cadManager,
        erp:        erpManager
    }
});



// WEBPACK FOOTER //
// ./src/_eng/store/store.js